import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Monitor from './pages/Monitor';
import Historial from './pages/Historial';
import Gestion from './pages/Gestion';
import Alertas from './pages/Alertas';
import Uptime from './pages/Uptime';
import Diagnostico from './pages/Diagnostico';
import AdminUsuarios from './pages/AdminUsuarios';
import CodigosError from './pages/CodigosError';
import LimitesZonal from './pages/LimitesZonal';
import MiPerfil from './pages/MiPerfil';
import Login from './pages/Login';
import './App.css';

const SinPermiso = () => (
  <div style={{padding:'3rem',textAlign:'center'}}>
    <div style={{fontSize:'40px',marginBottom:'12px'}}>🔒</div>
    <div style={{color:'var(--text2)',fontSize:'16px',fontWeight:'600'}}>Sin permisos para esta sección</div>
    <div style={{color:'var(--text3)',fontSize:'13px',marginTop:'6px'}}>Contacta al administrador para solicitar acceso</div>
  </div>
);

function App() {
  const [usuario, setUsuario] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('mueve_user');
    if (saved) { try { setUsuario(JSON.parse(saved)); } catch(e) {} }
    setChecking(false);
  }, []);

  const handleLogin = (user) => setUsuario(user);

  const handleLogout = () => {
    localStorage.removeItem('mueve_user');
    setUsuario(null);
  };

  if (checking) return null;
  if (!usuario) return <Login onLogin={handleLogin} />;

  const p = usuario.permisos || {};

  return (
    <Router>
      <div className="app">
        <Navbar usuario={usuario} onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={p.dashboard !== false ? <Dashboard /> : <SinPermiso />} />
            <Route path="/monitor" element={p.monitor !== false ? <Monitor usuario={usuario} /> : <SinPermiso />} />
            <Route path="/historial" element={p.historial !== false ? <Historial /> : <SinPermiso />} />
            <Route path="/gestion" element={p.gestion ? <Gestion /> : <SinPermiso />} />
            <Route path="/alertas" element={p.alertas !== false ? <Alertas /> : <SinPermiso />} />
            <Route path="/uptime" element={p.uptime !== false ? <Uptime /> : <SinPermiso />} />
            <Route path="/diagnostico" element={p.diagnostico !== false ? <Diagnostico /> : <SinPermiso />} />
            <Route path="/usuarios" element={p.usuarios ? <AdminUsuarios usuario={usuario} /> : <SinPermiso />} />
            <Route path="/errores" element={p.usuarios ? <CodigosError /> : <SinPermiso />} />
            <Route path="/limites" element={p.limites ? <LimitesZonal usuario={usuario} /> : <SinPermiso />} />
            <Route path="/perfil" element={<MiPerfil usuario={usuario} onLogout={handleLogout} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
